import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=798688c6"
import script from "./userRegister.vue?vue&type=script&lang=js"
export * from "./userRegister.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/userRegister.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/login/userRegister.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports